import { DateTimeRange } from "@app/shared/date-range-picker/date-time-range";
import { DivisionLoadsSummary } from "@app/truckload/truckload";
import { createActionGroup, props } from "@ngrx/store";

export const ExpediteDashboardActions = createActionGroup({
    source: 'Expedite Dashboard',
    events: {
        'Load New Expedite Summaries': props<{ customerCode: string }>(),
        'Load New Expedite Summaries Success': props<{ summaries: DivisionLoadsSummary[] }>(),        
        'Load New Expedite Summaries Error': props<{ message: string }>(),
        
        'Load Active Expedite Summaries': props<{ customerCode: string }>(),
        'Load Active Expedite Summaries Success': props<{ summaries: DivisionLoadsSummary[] }>(),        
        'Load Active Expedite Summaries Error': props<{ message: string }>(),
        
        'Load Completed Expedite Summaries': props<{ customerCode: string, dateTimeRange: DateTimeRange }>(),
        'Load Completed Expedite Summaries Success': props<{ summaries: DivisionLoadsSummary[] }>(),        
        'Load Completed Expedite Summaries Error': props<{ message: string }>()
    }
})
